/* --- SHUBHAM PRODUCT PAGE LOGIC --- */

// 1. Image Gallery Logic
function shubhamChangeImage(thumbElement) {
  const mainImg = document.getElementById('shubham-main-image');
  const newSrc = thumbElement.getAttribute('data-src');
  
  if (mainImg && newSrc) {
    mainImg.src = newSrc;
    document.querySelectorAll('.shubham-thumbnail').forEach(th => th.classList.remove('active'));
    thumbElement.classList.add('active');
  }
}

// 2. Quantity Box Logic
function shubhamUpdateQty(change) {
  const input = document.getElementById('shubham-quantity');
  if (input) {
    let newVal = parseInt(input.value) + change;
    if (newVal < 1) newVal = 1; 
    input.value = newVal;
  }
}

// 3. Variant Selection Logic (Safe DOM Updates)
function shubhamSelectVariant(btnElement) {
  if (btnElement.classList.contains('sold-out')) return; 

  const group = btnElement.closest('.shubham-option-values');
  group.querySelectorAll('.shubham-option-btn').forEach(btn => btn.classList.remove('selected'));
  btnElement.classList.add('selected');

  const selectedOptions = [];
  document.querySelectorAll('.shubham-option-btn.selected').forEach(btn => {
    selectedOptions.push(btn.getAttribute('data-value'));
  });

  const variantDataStr = document.getElementById('shubham-variant-data')?.textContent;
  if (!variantDataStr) return;
  const variants = JSON.parse(variantDataStr);
  
  const matchedVariant = variants.find(variant => {
    return selectedOptions.every((val, index) => variant.options[index] === val);
  });

  if (matchedVariant) {
    document.getElementById('shubham-variant-id').value = matchedVariant.id;
    
    // 3a. Update Prices cleanly (No HTML overwriting)
    const currentPriceEl = document.querySelector('.shubham-price-current');
    const comparePriceEl = document.querySelector('.shubham-price-compare');
    
    if (currentPriceEl) {
      currentPriceEl.textContent = 'Rs. ' + (matchedVariant.price / 100).toFixed(2);
    }
    
    if (comparePriceEl) {
      if (matchedVariant.compare_at_price > matchedVariant.price) {
        comparePriceEl.textContent = 'Rs. ' + (matchedVariant.compare_at_price / 100).toFixed(2);
        comparePriceEl.style.display = 'inline-block';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    // 3b. Update Urgency Tag securely using the new inventory dictionary
    const urgencyTag = document.getElementById('shubham-urgency-tag');
    const inventoryDataStr = document.getElementById('shubham-inventory-data')?.textContent;
    
    if (urgencyTag && inventoryDataStr) {
      const inventories = JSON.parse(inventoryDataStr);
      const exactStock = inventories[matchedVariant.id] || 0;
      
      if (exactStock > 0 && exactStock <= 10) {
        urgencyTag.innerHTML = `🔥 Just ${exactStock} left. Order soon!`;
      } else {
        urgencyTag.innerHTML = `🔥 Selling fast!`;
      }
    }

    // 3c. Update URL cleanly
    const url = new URL(window.location);
    url.searchParams.set('variant', matchedVariant.id);
    window.history.replaceState({}, '', url);

    // 3d. Update Main Image based on Variant Color
    if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
      const mainImg = document.getElementById('shubham-main-image');
      if (mainImg) {
        // Change the main image to the variant's assigned image
        mainImg.src = matchedVariant.featured_image.src;

        // Sync the active border on the correct thumbnail below it
        const baseUrl = matchedVariant.featured_image.src.split('?')[0]; 
        document.querySelectorAll('.shubham-thumbnail').forEach(th => {
          th.classList.remove('active');
          // If the thumbnail's data-src contains the base image name, make it active
          if (th.getAttribute('data-src').includes(baseUrl)) {
            th.classList.add('active');
          }
        });
      }
    }
  } // <-- Properly closed block
}

// 4. Zoom Hover Effect Logic
function shubhamInitHoverZoom() {
  const wrapper = document.querySelector('.shubham-main-image-wrapper');
  const img = document.getElementById('shubham-main-image');

  if(!wrapper || !img) return;

  wrapper.addEventListener('mousemove', function(e) {
    if (window.innerWidth > 768) {
      const rect = wrapper.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;
      img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
    }
  });

  wrapper.addEventListener('mouseenter', function() {
    if (window.innerWidth > 768) {
      wrapper.classList.add('is-zoomed');
    }
  });

  wrapper.addEventListener('mouseleave', function() {
    wrapper.classList.remove('is-zoomed');
    setTimeout(() => {
      if(!wrapper.classList.contains('is-zoomed')) {
         img.style.transformOrigin = '50% 50%';
      }
    }, 150); 
  });
}

document.addEventListener('DOMContentLoaded', shubhamInitHoverZoom);

// 5. AJAX Add to Cart Logic (No Reload + Opens Dawn Drawer)
window.shubhamProductAddToCart = function(button) {
  const form = document.getElementById('shubham-product-form');
  const errorContainer = form.querySelector('.shubham-cart-error-message');
  const variantInput = document.getElementById('shubham-variant-id');
  const quantityInput = document.getElementById('shubham-quantity');

  if (errorContainer) {
    errorContainer.style.display = 'none';
    errorContainer.textContent = '';
  }

  const originalText = button.textContent;
  button.textContent = 'Adding...';
  button.disabled = true;

  const formData = {
    'items': [{
      'id': variantInput.value,
      'quantity': parseInt(quantityInput.value) || 1
    }]
  };

  fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(async (response) => {
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || 'Not enough stock available.');
    }
    return response.json();
  })
  .then(() => {
    button.textContent = 'Added!';
    button.style.backgroundColor = '#4CAF50'; 
    button.style.color = '#fff';
    
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
      button.style.backgroundColor = ''; 
      button.style.color = '';
    }, 2000);

    // Fetch and update Dawn's native cart drawer without reloading the page
    fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newInner = temp.querySelector('.drawer__inner, #CartDrawer');
        const currentInner = drawer.querySelector('.drawer__inner, #CartDrawer');
        
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        } else {
          drawer.innerHTML = html; 
        }

        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('active', 'is-active');
        }
      }
    });

    // Update the cart icon bubble counter
    fetch('/?section_id=cart-icon-bubble')
    .then(res => res.text())
    .then(html => {
      const bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) {
        bubble.innerHTML = html;
      }
    });

  })
  .catch(error => {
    console.error('Add to cart failed:', error);
    
    if (errorContainer) {
      errorContainer.textContent = error.message;
      errorContainer.style.display = 'block';
    }

    button.textContent = 'Error';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2500);
  });
};